import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule,PreloadAllModules} from '@angular/router';
import {OwnersRoutingModule} from './owners-routing.module';
import {DetailComponent} from './components/detail.component';
import {OwnerComponent} from './components/owner.component';
import {SettingsComponent} from './components/settings.component';
import {OwnerCrudComponent} from './components/owner-crud.component';
import {OwnerExportComponent} from './components/owner-export.component';
import {OwnerService} from './services/owner.service';
import {GlobalDataService} from '../housekeeping/services/global-data.service';
import {FileUploadService} from '../housekeeping/services/file-upload.service';
import {FormsModule} from '@angular/forms';
import {CalendarModule} from 'primeng/primeng';
import {NgxPaginationModule} from 'ngx-pagination';
import {SortablejsModule} from 'angular-sortablejs';
import {SortPipeService} from '../../pipes/sort-pipe.service';
import {OwnerCrudService} from '../owners/services/owner-crud.service';
import {RoleGuardService} from '../../role-guard.service';
import { OwnerchangeComponent } from './components/ownerchange.component';
import { HousekeepingModule } from '../../../app/modules/housekeeping/housekeeping.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {YesNoPipe} from "../../pipes/yesno-pipe";
import {OwnerBulkComponent} from "./components/owner-bulk.component";
import {DndDirective} from "./components/DndDirective";
import { TooltipDirective } from "./components/TooltipDirective";


const routes: Routes = [
    {path: 'owners', component: OwnerComponent, canActivate: [RoleGuardService]},
    {path: 'owners/settings', component: SettingsComponent, canActivate: [RoleGuardService]},
    {path: 'owners/detail/:id/:vin/:vehicleId', component: DetailComponent, canActivate: [RoleGuardService]},
    {path: 'owners/create', component: OwnerCrudComponent, canActivate: [RoleGuardService]},
    {path: 'owners/edit/:id/:vin/:vehicleId', component: OwnerCrudComponent, canActivate: [RoleGuardService]},
    {path: 'owners/ownerchage/:id/:vin/:vehicleId', component: OwnerchangeComponent, canActivate: [RoleGuardService]},
    {path: 'owners/export', component: OwnerExportComponent, canActivate: [RoleGuardService]},
  {path: 'owners/bulk',component: OwnerBulkComponent,canActivate: [RoleGuardService]}
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CalendarModule,
        OwnersRoutingModule,
        HousekeepingModule,
        NgxPaginationModule,
        SortablejsModule.forRoot({
            animation: 200,
        }),
        RouterModule.forRoot(routes,
          {
            useHash: true,
            preloadingStrategy: PreloadAllModules
          }),
        NgMultiSelectDropDownModule.forRoot(),
    ],
    exports: [RouterModule],
    providers: [GlobalDataService, FileUploadService, OwnerService, SortPipeService, OwnerCrudService],
    declarations: [TooltipDirective,DndDirective,DetailComponent, OwnerComponent, SettingsComponent, OwnerCrudComponent, OwnerExportComponent, SortPipeService, OwnerchangeComponent, YesNoPipe,OwnerBulkComponent]


})
export class OwnersModule {}



// WEBPACK FOOTER //
// ./src/app/modules/owners/owners.module.ts